const employeeTypes = {
  Regular: 1,
  Irregular: 2,
  RemedioProvisional: 3  
};

export default employeeTypes;
